import * as React from 'react';

const partnerIcon = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 12.25V11.0833C1.5 10.4645 1.74583 9.871 2.18342 9.43342C2.621 8.99583 3.21449 8.75 3.83333 8.75H5.875M2.66667 4.08333C2.66667 4.70217 2.9125 5.29566 3.35008 5.73325C3.78767 6.17083 4.38116 6.41667 5 6.41667C5.61884 6.41667 6.21233 6.17083 6.64992 5.73325C7.0875 5.29566 7.33333 4.70217 7.33333 4.08333C7.33333 3.46449 7.0875 2.871 6.64992 2.43342C6.21233 1.99583 5.61884 1.75 5 1.75C4.38116 1.75 3.78767 1.99583 3.35008 2.43342C2.9125 2.871 2.66667 3.46449 2.66667 4.08333ZM8.745 9.10596C8.85876 8.99221 8.99381 8.90197 9.14244 8.8404C9.29107 8.77884 9.45037 8.74715 9.61125 8.74715C9.77213 8.74715 9.93143 8.77884 10.0801 8.8404C10.2287 8.90197 10.3637 8.99221 10.4775 9.10596C10.5913 9.21972 10.6815 9.35477 10.7431 9.5034C10.8046 9.65203 10.8363 9.81134 10.8363 9.97221C10.8363 10.1331 10.8046 10.2924 10.7431 10.441C10.6815 10.5897 10.5913 10.7247 10.4775 10.8385L8.5 12.8335H6.75V11.0835L8.745 9.10596Z"
      stroke="#0065FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default partnerIcon;
